import React from 'react'
import { Grid } from '@mui/material'
import { Alert } from '@e3dc-react/shell/Elements/Alert'
import { WallboxCard } from './WallboxCard'
import { WallboxModel } from '../models/wallbox-model'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { TariffCategory } from '../../shared/models/types'

interface WallboxCardsProps {
  wallboxes: WallboxModel[]
  installationId: number
}

/**
 *  Represents component for mapping and displaying wallbox cards.
 *  @param wallboxes - as array of WallboxModel
 *  @param installationId - unique installation identifier as string
 *  @param user - user data from account link which match logged user
 */
export const WallboxCards: React.VFC<WallboxCardsProps> = ({ wallboxes, installationId }): JSX.Element => {
  const { t } = useCustomTranslation()

  const isDynamicTariff = wallboxes.some(wallbox => wallbox.tariffToDisplay?.tariffCategory === TariffCategory.dynamicTariff)
  const shouldDisplayTariffChart = wallboxes.length === 1 && isDynamicTariff

  return (
    <Grid container spacing={3}>
      {wallboxes.length > 0 ? (
        wallboxes.map((wallbox, index) => (
          <Grid
            item
            xs={12}
            sm={shouldDisplayTariffChart ? 12 : 6}
            md={shouldDisplayTariffChart ? 12 : 6}
            xl={shouldDisplayTariffChart ? 12 : 4}
            key={wallbox.wallboxId}
          >
            <WallboxCard wallbox={wallbox} installationId={installationId} shouldDisplayTariffChart={shouldDisplayTariffChart} />
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Alert variant="filled" severity="info" text={t('shell.noData')} />
        </Grid>
      )}
    </Grid>
  )
}
